import { useConsent } from '@/lib/consent';
import { isGtmConfigured } from './client';

/**
 * Whether GTM may be used: consent allows non-essential services (off-GDPR or accepted on GDPR)
 * AND GTM is configured for this site (env). Reactive via useConsent, so consumers re-render when consent changes post-Accept or on withdrawal.
 */
export const useGtmEnabled = (): boolean => {
  const { allowed } = useConsent();
  return allowed && isGtmConfigured();
};
